import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5f2638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EmployeesFilters" }
const _hoisted_2 = { class: "EmployeesFilters__form" }
const _hoisted_3 = { class: "EmployeesFilters__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_input, {
          placeholder: "Сотрудник",
          value: _ctx.state.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.search) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Организация",
          loading: _ctx.data_state.organizations.is_loading,
          failed: _ctx.data_state.organizations.is_failed,
          options: _ctx.data_state.organizations.list,
          "error-text": "При получении списка организаций произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.organizationId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.organizationId) = $event)),
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadDictionary(3))),
          onSearch: _ctx.searchDictionaryThree
        }, null, 8, ["loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Отдел",
          loading: _ctx.data_state.departments.is_loading,
          failed: _ctx.data_state.departments.is_failed,
          options: _ctx.data_state.departments.list,
          "error-text": "При получении списка отделов произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.departmentId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.departmentId) = $event)),
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadDictionary(1))),
          onSearch: _ctx.searchDictionaryOne
        }, null, 8, ["loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Город",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          options: _ctx.data_state.cities.list,
          "error-text": "При получении списка городов произошла ошибка",
          "infinite-scroll": "",
          value: _ctx.state.cityId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.cityId) = $event)),
          onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
          onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
          onSearch: _ctx.searchCity,
          onOptionBySearch: _ctx.unshiftFindedCity
        }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Подразделение",
          loading: _ctx.data_state.subdivisions.is_loading,
          failed: _ctx.data_state.subdivisions.is_failed,
          options: _ctx.data_state.subdivisions.list,
          "error-text": "При получении списка подразделений произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.subdivisionId,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
          onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadDictionary(5))),
          onSearch: _ctx.searchDictionaryFive
        }, null, 8, ["loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата приема с",
          value: _ctx.state.dateOfReceiptFrom,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.dateOfReceiptFrom) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата приема по",
          value: _ctx.state.dateOfReceiptTo,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.dateOfReceiptTo) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата рождения с",
          value: _ctx.state.dateOfBirthFrom,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.dateOfBirthFrom) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата рождения по",
          value: _ctx.state.dateOfBirthTo,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.dateOfBirthTo) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Должность",
          loading: _ctx.data_state.jobs.is_loading,
          failed: _ctx.data_state.jobs.is_failed,
          options: _ctx.data_state.jobs.list,
          "error-text": "При получении списка должностей произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.jobId,
          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.jobId) = $event)),
          onRefresh: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadDictionary(2))),
          onSearch: _ctx.searchJob
        }, null, 8, ["loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_input, {
          placeholder: "E-mail адрес",
          value: _ctx.state.email,
          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.email) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Мобильный телефон",
          value: _ctx.state.phoneNumber,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["value", "maska"]),
        _createVNode(_component_the_input, {
          placeholder: "Рабочий телефон",
          value: _ctx.state.workPhone,
          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.workPhone) = $event)),
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["value", "maska"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          class: "mt-2",
          placeholder: "Состояние",
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          options: _ctx.data_state.statuses.list,
          "error-text": "При получении списка состояний произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.statusId,
          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.statusId) = $event)),
          onRefresh: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loadDictionary(4))),
          onSearch: _ctx.searchDictionaryFour
        }, null, 8, ["loading", "failed", "options", "value", "onSearch"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second text small mr-2",
          loading: _ctx.loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сброс ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}